<template>
  <div>
    <div class="row-tb-head" style="margin-top: 10px">
      <span>配件信息</span>
    </div>
    <el-table
      ref="table"
      class="table_bottom table-line tb-c-head"
      :data="tableData"
      border
    >
      <el-table-column
        prop="ProductNo"
        label="配件编码"
        min-width="160"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="ProductName"
        label="配件名称"
        min-width="160"
        align="center"
      >
        
      </el-table-column>
      <el-table-column prop="ProductSpec" label="规格" min-width="110" align="center">
      </el-table-column>
      <el-table-column
          prop="PdUnitName"
          label="单位"
          min-width="126"
          align="center"
        >
        </el-table-column>
      <el-table-column
        prop="Quantity"
        label="需求数量"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="ImgUrl" label="图片" min-width="110" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)">{{row.ProductId ? '查看' : ''}}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="Remarks"
        label="备注"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="ProduceTypeName"
        label="存货类型"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="Bomno"
        label="bom版本"
        min-width="110"
        align="center"
      >
      </el-table-column>
    </el-table>

    <div class="row-tb-head" style="margin-top: 10px">
      <span>工艺</span>
    </div>

    <el-table
      :data="ProcessData"
      class="table_bottom table-line tb-c-head"
      border
      ref="list3"
    >
     <el-table-column
        prop="ProductName"
        label="产品名称"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="ProductNo"
        label="产品编码"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="ProgrammeName"
        label="工艺方案名称"
        min-width="120"
      >
        <template slot-scope="{ row }">
           <el-button type="text" @click="changeProgramme(row)">{{row.ProgrammeName ? row.ProgrammeName : '选择方案'}} </el-button>
        </template>
      </el-table-column>
       <el-table-column
        label="方案详情"
        min-width="120"
      >
        <template slot-scope="{ row }">
           <el-button type="text" @click="changeProgrammeInfo(row)">详情编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div  v-for="(item, index) in detailData" :key="index">
       <div class="row-tb-head" style="margin-top: 10px">
      <span>{{item.name}}子件信息</span>
    </div>
    <el-table
      ref="sub_table"
      class="table_bottom table-line tb-c-head"
      :data="item.DetailModels"
      border
    >
      <el-table-column
        prop="ProductNo"
        label="子件编码"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="ProductName"
        label="子件名称"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="ProductSpec" label="规格" min-width="110" align="center">
      </el-table-column>
     <el-table-column
          prop="PdUnitName"
          label="单位"
          min-width="126"
          align="center"
        >
        </el-table-column>
      <el-table-column
        prop="Quantity"
        label="需求数量"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="ImgUrl" label="图片" min-width="110" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)">{{row.ProductId ? '查看' : ''}}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="Remarks" 
        label="备注"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="ProduceTypeName"
        label="存货类型"
        min-width="110"
        align="center"
      >
      </el-table-column>
    </el-table>
    </div>
   
     <!-- <bom-dialog ref="bomDialog" :columns="columns" :item="tempItem" :inner-columns="innerColumns" @saved="saved"></bom-dialog> -->
     <come-list-dialog @select="comeSelect" ref="comeListDialog" in-dialog />
    <img-dialog ref="imgDialog" :imgs="imgs" />
    <list-dialog ref="listDialog" selectable :multiple="false" @select="listDialogSelect"></list-dialog>
    <detail-dialog ref="detailDialog" @saved="detail_saved"></detail-dialog>
  </div>
</template>

<script>
import bomDialog from './bomDialog'
import accountSelect from '@/components/production/clothmanagement/cloth/select'
import comeListDialog from "@/components/basedata/business/come/listDialog";
import imgDialog from './imgDialog'
import listDialog from '@/components/production/craftsmanship/solutions/fittings/listDialog'
import detailDialog from "./detailDialog";
import { urlHttp } from './bomConfig'


export default {
  name: "wjFittings",
  components: {
    bomDialog,
    imgDialog,
    accountSelect,
    comeListDialog,
    listDialog,
    detailDialog,
  },
  props: {
    Parts: {
      type: Array,
      default: () => []
    },
    productData: {
      type: Array,
      default: () => []
    },
    processListProp: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    Parts(data){
      console.log('====Parts data====', data)
      let arr = [];
      let ProcessData = [];
      let detailData = [];
      data.forEach(item => {
        let {DetailModels, ProcessModels, ...rest} = item;
        arr.push(rest);
        ProcessData.push(...ProcessModels);
        ProcessModels.forEach(v => {
          v.ProductName = rest.ProductName;
          v.ProductNo = rest.ProductNo;
        })
        let o = {
          name: rest.ProductName,
          DetailModels
        }
        detailData.push(o)
      })
      this.tableData = arr;
      this.ProcessData = ProcessData;
      this.detailData = detailData;

    },
  },
  data() {
    return {

      tableData: [],
      ProcessData: [],
      detailData: [],
      tempItem: {},
      pdApi: require('@/api/ba/product').default,
      teProcessApi: require('@/api/production/teProcess').default,
      processList: [],
      initDAccount:[],
      initTotal:0,
      DAccount: [],
      listTotal:0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      delTable: [],
      currentRow: null,
      craftData: [],
      subTableData: [],
      imgs: [],
      delCraftData: [],
      columns: [
        {
          key: "Pno",
          prop: "Pno",
          lable: "产品编码",
        },
        {
          key: "Pname",
          prop: "Pname",
          lable: "产品名称",
        },
        {
          key: "ProductSpec",
          prop: "ProductSpec",
          lable: "规格",
        },
        {
          key: "PdUnitName",
          prop: "PdUnitName",
          lable: "单位",
        },
        {
          key: "ImgUrl",
          prop: "ImgUrl",
          lable: "图片",
        },
         {
          key: "Remarks",
          prop: "Remarks",
          lable: "备注",
        },
        {
          key: "ProduceTypeName",
          prop: "ProduceTypeName",
          lable: "存货类型",
        },
        {
          key: "Bomno",
          prop: "Bomno",
          lable: "BOM版本",
        },
      ],
      innerColumns: [
        {
          key: "ProductNo",
          prop: "ProductNo",
          lable: "子件编码",
        },
        {
          key: "ProductName",
          prop: "ProductName",
          lable: "子件名称",
        },
        {
          key: "ProductSpec",
          prop: "ProductSpec",
          lable: "规格",
        },
        {
          key: "PdUnitName",
          prop: "PdUnitName",
          lable: "单位",
        },
        {
          key: "ImgUrl",
          prop: "ImgUrl",
          lable: "图片",
        },
        {
          key: "Remarks",
          prop: "Remarks",
          lable: "备注",
        },
        {
          key: "ProduceTypeName",
          prop: "ProduceTypeName",
          lable: "存货类型",
        },
      ]
    };
  },
  created(){
    // this.pdApi.list({Status: 1}).then(res => {

    //   if(res.Code === 0){
    //     let data =  res.Data.filter(item => {
    //       return item.ProcessStage !== 3 && item.ProcessStage !== 4
    //     })

    //     this.DAccount = data;
    //     this.initDAccount = data;
    //     this.listTotal = data.length;
    //     this.initTotal = data.length;
    //   }
      
    // })

    // this.teProcessApi.list({}).then(res => {
    //   if(res.Code === 0){
    //     this.processList = res.Data;

    //   }
    // })
  },
  methods: {
    delProcess(index, o){
      let row = this.craftData[index];
      if(row){
        row.T = 2;
        this.delCraftData.push(row);
        if(o){
          this.craftData.splice(index, 1, o);
        }else{
          this.craftData.splice(index, 1);
        }
      }

    },
    changeProgramme(row){
      this.currentRow = row
      this.$refs.listDialog.open()
    },
    changeProgrammeInfo(row){
      this.currentRow = row
      this.$refs.detailDialog.open().then(that => {
        that.setTableData(row)
      })
      console.log('row', row)
    },
    listDialogSelect(list){
      this.currentRow.ProgrammeName = list.ProgrammeName;
      this.currentRow.Processes = list.Processes;
      this.currentRow.ProgrammeId = list.ProgrammeId;
    },
    detail_saved(list){
      this.currentRow.Processes = list;
    },
    selectCome(row){
      this.currentRow = row;
      this.$refs.comeListDialog.open();
    },
    comeSelect(row){
      this.currentRow.TradeUnitId = row.TradeUnitId;
      this.currentRow.FullName = row.FullName;
    },
    onSelect(e,row){
      if(row.T !== 0){
        row.T = 1
      }
      console.log('wjFittings e========', e)
      row.ColorId = null;
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductSpec = e.ProductSpec;
      row.ProcessStage = e.ProcessStage;
      row.ProduceTypeName = e.ProduceTypeName;
      row.ProductId = e.ProductId;
      row.Colors = e.Colors
      row.PdUnitName = e.PdUnitName;
      row.PdUnitId = e.PdUnitId;
      row.UseColor = e.UseColor;
      row.Property = null;

    },
    resetFun(){
      this.pageParams.pageIndex=1
      this.DAccount=this.initDAccount
      this.listTotal=this.initTotal
    },
    currentPage(val){
      
      this.pageParams.pageIndex=val
          this.pdApi.list({ Status: 1 }).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal=res.Count
            }
      });
    },
    inputText(text){
       this.pdApi.list({ ProductName:text}).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            
            this.listTotal=res.Count
            }
          });
    },
     processChange(row){ 
      let id = row.ProcessId;
      let ids = this.processList.map(item => {
        return item.ProcessId
      })
      let index = ids.indexOf(id);
      row.Sn = this.processList[index].Sn;

    },
    add(list) {
       list.child.push({
          T: 0,
          ColorId: null, 
          UnitId: "", 
          Quantity: 0, 
  
          AddTime: "",
          AddUserId: "",
          AddUserName: "",
          BaseUnitId: "",
          BatchNumber: "",
          ClassId: "",
          ClassName: "",
          Colors: "",
          DefaultSupplier: "",
          DefaultWarehouse: "",
          ExpireDay: "",
          GoldenTaxCode: "",
          GrossWeight: "",
          HasExpire: "",
          IdChain: "",
          ImgUrl: "",
          LeadTime: "",
          MaxStock: "",
          MinStock: "",
          Mould: "",
          MouldId: "",
          MouldName: "",
          MouldRubberId: "",
          NetWeight: "",
          PdUnitId: "",
          PdUnitName: "",
          ProcessStage: "",
          ProduceTypeName: "",
          ProductId: "",
          ProductName: "",
          ProductNo: "",
          ProductSpec: "",
          ProductStatusId: "",
          ProductType: "",
          Property: "",
          PuUnitId: "",
          PuUnitName: "",
          Rate: "",
          RpUnitId: "",
          RpUnitName: "",
          SaUnitId: "",
          SaUnitName: "",
          SafetyStock: "",
          ShortName: "",
          SkUnitId: "",
          SkUnitName: "",
          Sn: "",
          Status: "",
          StatusName: "",
          TradeUnitFullName: "",
          TradeUnitShortName: "",
          UnitGroupId: "",
          UnitType: "",
          Units: "",
          UpdateTime: "",
          UpdateUserId: "",
          UpdateUserName: "",
          UseColor: "",
          UseProcess: "",
          ValuationId: "",
          ValuationName: "",
          Volume: "",
          WarehouseName: "",
          WarehouseNo: "",
      })
    },
    select(item, index) {
      let Pname = this.tableData[index].ProductName;
      this.tempItem = item;
      this.$refs.bomDialog.open().then(that => {
        that.getList(2, Pname);
      })
    },
    setSubTableData(arr) {
      // 父组件调用，设置子件列表
      this.subTableData = arr;
    },
    setCraftData(data){
      let arr = [];

       if(data.length !== 0){
        data.forEach(item => {
          item.ProcessModels.forEach(v => {
            v.T = 1
          })
        })

        data.forEach(item => {
          let o = {
            ProductName: item.Pname,
            ProductNo: item.Pno,
            ProgrammeId: item.ProcessModels[0].ProgrammeId,
            ProgrammeName: item.ProcessModels[0].ProgrammeName,
            Processes: item.ProcessModels
          }
          arr.push(o)
        })
      
        this.craftData = arr;
      }else{
         this.craftData = [];
      }
    },
    del(row, index, list) {
      this.$confirm("确定删除这些记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(res => {
        if(row.T !== 0){
          row.T = 2
        }
        this.delTable.push(row)
        list.child.splice(index, 1);
        
      })
    },
    saved(list, item){
      item.child = [];
      this.$nextTick(() => {
        item.child.push(...list);
      })
    },
    base64ToFile(dataurl, filename) {//将base64转换为文件
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg);
      const ImgUrl = res.Data;
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！');
      let imgs = [];
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl));
        // imgs.push(imgBlob);
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs;
      this.$refs.imgDialog.open();
    },
    // viewImg(ImgUrl) {
    //   let imgs = ImgUrl.split(',');
    //   imgs.forEach(item => {
    //     item = urlHttp + item
    //   })

    //   this.imgs = imgs;
    //   this.$refs.imgDialog.open();
    // },
    changeQuantity(val, row){
      if(row.T !== 0){
        row.T = 1
      }
    },
    changeRemark(val, row){
      if(row.T !== 0){
        row.T = 1
      }
    },
  
    getProcess(Processes, mode){
      let arr = [];
      Processes.forEach(item => {

        let {
          T,
          DpId,
          ProcessId,
          ProcessName,
          ProcessNo,
          ProcessType,
          ProcessSn,
          ProgrammeId,
          ProgrammeName,
          Stage,
          TeProductProcessId = 0,
          TebomId = 0,
          BomType = 2,
        } = item;
        BomType = 2

        let o = {}

        if(mode === 0){
          o = {
            T,
            DpId,
            ProcessId,
            ProcessName,
            ProcessNo,
            ProcessType,
            ProgrammeId,
            ProcessSn,
            ProgrammeName,
            Stage,
            TeProductProcessId,
            TebomId,
            BomType,
          }
        }else{
          o = {
            DpId,
            ProcessId,
            ProcessName,
            ProcessNo,
            ProcessType,
            ProgrammeId,
            ProcessSn,
            ProgrammeName,
            Stage,
            TeProductProcessId,
            TebomId,
            BomType,
          }
        }

        arr.push(o);
         
      })

      return arr
    },
    getProgramme(mode = 0){
      let arr = [];
      this.craftData.forEach(item => {
        let ProcessModels =  this.getProcess(item.Processes, mode)
        let o ={
          ProcessModels,
          ProgrammeId: item.ProgrammeId ? item.ProgrammeId : 0
        }
        arr.push(o)
      })

      return arr
    },
    getDetailModels(index, mode = 0, _TebomId) {
      let child = this.subTableData[index].child;

      let DetailModels = [];
      child.forEach((item) => {
        console.log("item", item);

        if(mode === 0){
          if(item.T != null){
            let {
              T,
              ProductId,
              Quantity,
              ProductNo,
              ColorId,
              ProductName,
              ProcessStage,
              Property = 0,
              ProductSpec,
              TeProductDetailId = 0,
              TebomId = 0,
              BomType = 2,
              Remarks = "",
            } = item;
            BomType = 2;
            if(Property == null){
              Property = 0;
            }
            ColorId = ColorId ?? 0;

            Quantity = Number(Quantity);

          let o = {
            T,
            ProductId,
            Quantity,
            ProductNo,
            ProductName,
            Property,
            ProcessStage,
            ProductSpec,
            TeProductDetailId,
            TebomId,
            BomType,
            Remarks
          };

          DetailModels.push(o);
          }
        }else{
           let {
              ProductId,
              Quantity,
              ProductNo,
              ColorId,
              ProductName,
              ProcessStage,
              TeProductId = 0,
              Property = 0,
              ProductSpec,
              TeProductDetailId = 0,
              TebomId = 0,
              BomType = 2,
              Remarks = "",
            } = item;
            BomType = 2;
            if(Property == null){
              Property = 0;
            }
            ColorId = ColorId ?? 0;

            Quantity = Number(Quantity);

          let o = {
            ProductId,
            TeProductId,
            Quantity,
            ProductNo,
            ProductName,
            Property,
            ProcessStage,
            ProductSpec,
            TeProductDetailId,
            TebomId,
            BomType,
            Remarks
          };

          DetailModels.push(o);
        }
        
      });

      if(mode === 0){
        this.delTable.forEach(item => {

          if(_TebomId === item.TebomId){
            let {
              T,
              ProductId,
              ColorId = 0,
              Quantity,
              ProductNo,
              Property = 0,
              ProductName,
              BomType = 4,
              Remarks,
              ProcessStage,
              ProductSpec,
              ColorName,
              TeProductDetailId = 0,
              TebomId = 0,
            } = item;
            BomType = 4
            Quantity = Number(Quantity);
            if(Property == null){
              Property = 0;
            }
            ColorId = ColorId ?? 0;

            let o = {
              T,
              ProductId,
              ColorId,
              Quantity,
              ProductNo,
              Property,
              ProductName,
              Remarks,
              ProcessStage,
              BomType,
              ProductSpec,
              ColorName,
              TeProductDetailId,
              TebomId,
            };

            DetailModels.push(o);
          }
          
        })
      }

      return DetailModels;
    },
    getSaveData(mode = 0) {
      let BomModels = [];
      let bool = true;

      this.tableData.forEach((item, index) => {
        let {
          ProductId,
          ColorId,
          Bomno,
          Quantity,
          ProductName,
          ProductNo,
          ColorName,
          ProduceTypeName,
          ProcessStage,
          ProductSpec,
          TebomId = 0,
          BomType = 2,
          Remarks = "",
        } = item;
        BomType = 2
        Quantity = Number(Quantity);
        ColorId = ColorId ?? 0;

        if(Bomno == null || Bomno == ""){
          this.$message({type: 'warning', message: '请填写配件BOM版本'})
          bool = false
        }

        let DetailModels = this.getDetailModels(index, mode, TebomId);
         if(mode === 1 && DetailModels.length === 0){
          bool = false
        }

        let Programme = this.getProgramme(mode);

        if(mode === 1){
          Programme.forEach(item => {
            if(item.ProgrammeId == 0){
              bool = false;
            }
          })
        }

        let o = {
          DetailModels,
          ProductId,
          ColorId,
          Bomno,
          Quantity,
          ProductName,
          ProductNo,
          ColorName,
          ProgrammeId: Programme[index] ? Programme[index].ProgrammeId : 0,
          ProcessModels: Programme[index] ? Programme[index].ProcessModels : [],
          ProduceTypeName,
          ProcessStage,
          ProductSpec,
          TebomId,
          BomType,
          Remarks
        };
        BomModels.push(o);
      });

      console.log('配件 BomModels', BomModels)

      if(bool){
        return BomModels;
      }else{
        return []
      }
    },
    copyDetailModels(index) {
      let child = this.subTableData[index].child;

      let DetailModels = [];
      child.forEach((item) => {
         let {
            T,
            ProductId,
            Quantity,
            ProductNo,
            ProductName,
            ProcessStage,
            Property = 0,
            ProductSpec,
            TeProductDetailId = 0,
            TebomId = 0,
            BomType = 2,
            Remarks = "",
            ColorId = 0,
          } = item;
          BomType = 2;
          if(Property == null){
            Property = 0;
          }
          ColorId = ColorId ?? 0;
          Quantity = Number(Quantity);

          let o = {
            T,
            ProductId,
            Quantity,
            ProductNo,
            ProductName,
            Property,
            ProcessStage,
            ProductSpec,
            TeProductDetailId,
            TebomId,
            BomType,
            Remarks
          };


        DetailModels.push(o);


        
      });

      return DetailModels;
    },
    copyData(mode = 0) {
      let BomModels = [];
      let bool = true;

      this.tableData.forEach((item, index) => {
        let {
          ProductId,
          ColorId,
          Bomno,
          Quantity,
          ProductName,
          ProductNo,
          ColorName,
          ProduceTypeName,
          ProcessStage,
          ProductSpec,
          TebomId = 0,
          BomType = 2,
          Remarks = "",
        } = item;
        BomType = 2
        ColorId = ColorId ?? 0;
        Quantity = Number(Quantity);
    

        if(Bomno == null || Bomno == ""){
          this.$message({type: 'warning', message: '请填写配件BOM版本'})
          bool = false
        }

        let DetailModels = this.copyDetailModels(index);
         if(mode === 1 && DetailModels.length === 0){
          bool = false
        }

        let Programme = this.getProgramme(mode);

        if(mode === 1){
          Programme.forEach(item => {
            if(item.ProgrammeId == 0){
              bool = false;
            }
          })
        }

        let o = {
          DetailModels,
          ProductId,
          ColorId,
          Bomno,
          Quantity,
          ProductName,
          ProductNo,
          ColorName,
          ProgrammeId: Programme[index] ? Programme[index].ProgrammeId : 0,
          ProcessModels: Programme[index] ? Programme[index].ProcessModels : [],
          ProduceTypeName,
          ProcessStage,
          ProductSpec,
          TebomId,
          BomType,
          Remarks
        };
        BomModels.push(o);
      });

      console.log('配件 BomModels', BomModels)

      if(bool){
        return BomModels;
      }else{
        return []
      }
    },
  },
};
</script>

<style lang="scss" scoped>
 .flex{
  display: flex;
 }
</style>
